import type { ReactElement } from "react";
import { useCallback } from "react";

import {
    StyledLeadsBaseContentContainer,
    StyledLeadsTabContent,
    StyledLeadsTableWrapper,
} from "app/pages/sales-intelligence/common-components/layout";
import { SearchResultsTableFallback } from "app/pages/sales-intelligence/common-components/search-results-table";
import type { TabContentComponentProps } from "app/pages/sales-intelligence/common-components/tabbed-page-content";
import type { PageTabBase } from "app/pages/sales-intelligence/common-components/tabbed-page-content/types";
import type { AppsSearchTableData } from "app/pages/sales-intelligence/modules/apps-search/types/table";
import FindAppsAndroidFiltersContainer from "app/pages/sales-intelligence/modules/find-apps-filters/containers/FindAppsAndroidFiltersContainer";
import { fromDtoToColumnsConfig } from "app/pages/sales-intelligence/modules/leads-search/utils";
import type { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type {
    IFindAppsAndroidRowDto,
    IFindAppsResponseDto,
} from "app/pages/sales-intelligence/store/find-apps/types/dto";

import { androidTableColumnConfig } from "../configuration/columns/androidColumnConfig";
import { useAndroidAppsData } from "../queries/useGetAppsData";

import FindAppsTableContainer from "./find-apps-table/FindAppsTableContainer";

const FindAppsAndroidTabContentContainer = ({
    shouldRenderDeferredContent = true,
}: TabContentComponentProps<PageTabBase<AppsSourceType>>): ReactElement => {
    const transformData = useCallback((data: IFindAppsResponseDto): AppsSearchTableData<IFindAppsAndroidRowDto> => {
        return { ...data, columns: fromDtoToColumnsConfig(data.columns, androidTableColumnConfig) };
    }, []);

    const { data, isFetching } = useAndroidAppsData(transformData);

    return (
        <StyledLeadsTabContent>
            <StyledLeadsBaseContentContainer>
                <FindAppsAndroidFiltersContainer />
            </StyledLeadsBaseContentContainer>

            <StyledLeadsTableWrapper>
                <SearchResultsTableFallback isVisible={!shouldRenderDeferredContent}>
                    <FindAppsTableContainer<IFindAppsAndroidRowDto>
                        isLoading={isFetching}
                        data={data}
                    />
                </SearchResultsTableFallback>
            </StyledLeadsTableWrapper>
        </StyledLeadsTabContent>
    );
};

export default FindAppsAndroidTabContentContainer;
